<!-- HM training list -->
<template>
  <div>
    <span v-for="(value, key) in training" :key="key">
      <span v-if="showIcon" v-html="iconDays(value)" />
      {{trainingMap.Training[key].name}}<span v-if="showDate">: {{value|formatDate('YYYY-MM-DD')}}</span>
      <br />
    </span>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'HMTrainingList',
  props: {
    training: {
      type: Object
    },
    showDate: {
      type: Boolean,
      default: false
    },
    showIcon: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {}
  },
  computed: {
    ...mapState('maps', ['trainingMap'])
  },
  methods: {
    iconDays(d) {
      return (this.$options.filters.daysOldIcon(d));
    }
  }
}
</script>
